import type { HTMLAttributes, Ref } from 'react';
import type { FontSize } from '../tokens/tokens';
import styles from './Heading.module.css';

export interface HeadingProps extends HTMLAttributes<HTMLHeadingElement> {
  /** Document outline level – chosen by structure, not by looks. */
  level: 1 | 2 | 3 | 4 | 5 | 6;
  /** Visual size; defaults to a size matching the level. */
  size?: Extract<FontSize, 'sm' | 'md' | 'lg' | 'xl' | '2xl' | '3xl' | '4xl'>;
  /** Text balancing across lines (default on). */
  balance?: boolean;
  ref?: Ref<HTMLHeadingElement>;
}

/** Page title 28, section title 17, sub-section 15 (docs/ux-richtlinien.md §2). */
const defaultSize = {
  1: '3xl',
  2: 'lg',
  3: 'md',
  4: 'md',
  5: 'sm',
  6: 'sm',
} as const;

export function Heading({ level, size, balance = true, className, ...rest }: HeadingProps) {
  const Element = `h${level}` as const;
  const classes = [
    styles.heading,
    styles[`size-${size ?? defaultSize[level]}`],
    balance && styles.balance,
    className,
  ]
    .filter(Boolean)
    .join(' ');
  return <Element className={classes} {...rest} />;
}
